// Auto-generated enum from table Pages

export const tabName = {
    activities: 'activities',
    adminCredits: 'adminCredits',
    auditHistory: 'auditHistory',
    auditLog: 'auditLog',
    categories: 'categories',
    claimActions: 'claimActions',
    claims: 'claims',
    configuration: 'configuration',
    contactDescription: 'contactDescription',
    contactPhotos: 'contactPhotos',
    contacts: 'contacts',
    contactTypes: 'contactTypes',
    creditTypes: 'creditTypes',
    customers: 'customers',
    domainCredits: 'domainCredits',
    domainDescription: 'domainDescription',
    domainMessages: 'domainMessages',
    domainPhotos: 'domainPhotos',
    domains: 'domains',
    domainUserDomainPhotos: 'domainUserDomainPhotos',
    domainUserProfilePhotos: 'domainUserProfilePhotos',
    domainUsers: 'domainUsers',
    employees: 'employees',
    functionMemberPeriods: 'functionMemberPeriods',
    functionMembers: 'functionMembers',
    functionMessages: 'functionMessages',
    functions: 'functions',
    homeChats: 'homeChats',
    homeMessages: 'homeMessages',
    images: 'images',
    invitations: 'invitations',
    noticeDescription: 'noticeDescription',
    noticePhotos: 'noticePhotos',
    notices: 'notices',
    observationTypes: 'observationTypes',
    pageActivities: 'pageActivities',
    pageComponents: 'pageComponents',
    pages: 'pages',
    projectChats: 'projectChats',
    projectDescription: 'projectDescription',
    projectMemberPhotos: 'projectMemberPhotos',
    projectMembers: 'projectMembers',
    projectMessages: 'projectMessages',
    projectPhotos: 'projectPhotos',
    projects: 'projects',
    projectTasks: 'projectTasks',
    roles: 'roles',
    suppliers: 'suppliers',
    tabs: 'tabs',
    taskChats: 'taskChats',
    taskDescription: 'taskDescription',
    taskHistory: 'taskHistory',
    taskMembers: 'taskMembers',
    taskMessages: 'taskMessages',
    taskNotices: 'taskNotices',
    taskPhotos: 'taskPhotos',
    taskSubtasks: 'taskSubtasks',
    taskTypes: 'taskTypes',
    themeColors: 'themeColors',
    themeIcons: 'themeIcons',
    themes: 'themes',
    themeSemantic: 'themeSemantic',
    themeTypography: 'themeTypography',
    userPhotos: 'userPhotos',
    users: 'users',
}

export type TTabName = (typeof tabName)[keyof typeof tabName];

